import React, { useState, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import Page from "../../../../../components/Page";
import { Box, Divider } from "@mui/material";
import Header from "./Header";
import Loader from "../../../../../components/Loader";
import Usage from "./Usage";
import Feedbacks from "./Feedbacks";
import Users from "./Users";
import Files from "./Files/Files";
import Filters from "./Filters/Filters";
import { getDashboardData } from "../../../../../core/repo/accountRepo";
import { useDispatch } from "react-redux";
import { dateFilterOptions } from "./Filters/DateFilter";

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 8,
    background: theme.palette.background.dark,
  },
  container: {
    borderRadius: 24,
    border: `1px solid ${theme.palette.divider}`,
    width: "100%",
    height: "100%",
    background: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
}));

function Dashboard() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState("all");
  const [dashboardData, setDashboardData] = useState(null);
  const [dateFilter, setDateFilter] = useState(dateFilterOptions[4]);

  const handleDomainChange = (domain) => {
    setSelectedDomain(domain);
  };

  const handleDateFilterChange = (dateFilter) => {
    setDateFilter(dateFilter);
  };

  const fetchDashboardData = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(
        getDashboardData(
          selectedDomain === "all" ? "" : selectedDomain,
          dateFilter.value
        )
      );
      setDashboardData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [selectedDomain, dateFilter]);

  return (
    <Page title="Dashboard" className={classes.root}>
      <Box className={classes.container} position="relative">
        <Header />
        <Divider />
        {isLoading || !dashboardData ? (
          <Loader />
        ) : (
          <Box p={3} flex={1} overflow="auto">
            <Filters
              selectedDomain={selectedDomain}
              onDomainChange={handleDomainChange}
              dateFilter={dateFilter}
              onDateFilterChange={handleDateFilterChange}
            />
            <Box mb={4} />
            <Usage usage={dashboardData.usage} />
            <Box mb={4} />
            <Feedbacks feedbacks={dashboardData.feedbacks} />
            <Box mb={4} />
            <Files files={dashboardData.files} />
            <Box mb={4} />
            <Users users={dashboardData.users} />
          </Box>
        )}
      </Box>
    </Page>
  );
}

export default Dashboard;
